module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0161.jpg?v=31fbb7e3";